import { Modal, Input, message, Select, Divider, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import axios from "axios";

const AddActivity = ({ visible, onClose, id, StoryOptionLabel }) => {
  const [title, setTitle] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [stories, setStories] = useState([]);
  const [characters, setCharacters] = useState([]);
  const [members, setMembers] = useState([]);

  const [existingTasks, setExistingTasks] = useState([]);

  const [selectedStory, setSelectedStory] = useState(null);
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [taskType, setTaskType] = useState(null);
  const [assignedMember, setAssignedMember] = useState(null);


  useEffect(() => {
    if (!visible) return;
    setTitle("");
  }, [visible]);
  useEffect(() => {
    setSelectedStory(null);
    if (visible) {
      axios
        .get("/api/stories")
        .then((res) => setStories(res.data))
        .catch((error) => {
          message.error("Fehler beim Laden der Geschichten.");
          console.error("Error fetching stories:", error);
        });
    }
  }, [visible]);
  const storyIconStyle = {
    width: 24,
    height: 24,
    objectFit: "cover",
    borderRadius: 4,
  };

  const storyIconStyleSelected = {
    width: 18,
    height: 18,
    objectFit: "cover",
    borderRadius: 4,
  };
  
  // When a story is selected, fetch its characters
  const handleStoryChange = async (storyId) => {
    setSelectedStory(storyId);
    setCharacters([]); // Reset characters when a new story is selected
    setMembers([]); // Reset members when a new story is selected
    setExistingTasks([]); // Reset existing tasks
    setSelectedCharacters(
      // ALL_CHARACTERS_TASK_TYPES.has(taskType) ? ["alles"] : []
    ); // Reset selected characters when a new story is selected
    
    try {
      const charResponse = await axios.get(
        `/api/characters/?storycharid=${storyId}`
      );
      console.log("charResponse:", charResponse);
      setCharacters(charResponse.data);

      const membersResponse = await axios.get(`/api/groups/${id}/members`);
      console.log("membersResponse:", membersResponse);
      setMembers(membersResponse.data);

      // Fetch existing tasks for this story within the current group
      const tasksResponse = await axios.get(`/api/tasks/${id}/${storyId}`);
      console.log("tasksResponse:", tasksResponse);
      setExistingTasks(tasksResponse.data); // Store tasks so we can filter characters
    } catch (error) {
      message.error("Fehler beim Laden der Daten.");
      console.error("Error fetching characters or members:", error);
    }
  };

  const handleSubmit = async () => {
    console.log("Selected Story:", selectedStory);
    if (!title.trim()) {
      message.error("Bitte gib einen gültigen Titel ein.");
      return;
    }

    try {
      setSubmitting(true);
      await axios.post("/api/activities", {
        class_id: id,
        title: title.trim(),
        story_id: selectedStory,
      });
      message.success("Aktivität wurde erstellt.");
      onClose();
    } catch (error) {
      console.error("Error creating activity:", error);
      message.error("Fehler beim Erstellen der Aktivität.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Neue Aktivität hinzufügen"
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={
        <span>
          <PlusOutlined /> Erstellen
        </span>
      }
      confirmLoading={submitting}
      cancelText="Abbrechen"
    >
      <Input
        placeholder="Titel der Aktivität"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ marginBottom: "8px" }}
      />
      <Select
        placeholder="Wähle eine Geschichte"
        style={{ width: "100%", marginBottom: "10px" }}
        value={selectedStory}
        onChange={handleStoryChange}
        optionLabelProp="label"
        loading={!stories.length} // Show loading state while fetching
      >
        {stories.map((story, index) => (
          <Select.Option
            key={story.id}
            value={story.id}
            label={
              <StoryOptionLabel
                text={story.title}
                imgSrc={story.img ? `/api/stories/imagefile/${story.img}` : null}
                iconStyle={storyIconStyleSelected}
              />
            }
          >
            <div>
              <StoryOptionLabel
                text={story.title}
                imgSrc={story.img ? `/api/stories/imagefile/${story.img}` : null}
                iconStyle={storyIconStyle}
              />
              {index < stories.length - 1 ? (
                <Divider style={{ margin: "8px 0 0" }} />
              ) : null}
            </div>
          </Select.Option>
        ))}
      </Select>
    </Modal>
  );
};

export default AddActivity;
